const MODULE_NAME = 'ChangeLogModule';

export const GET_JOB_CHANGELOG = `${MODULE_NAME}/GET_JOB_CHANGELOG`;
export const RESET_JOB_CHANGELOG = `${MODULE_NAME}/RESET_JOB_CHANGELOG`;
